import { colors as c } from '@britishcouncil/react-registration-platform';

export const regPlatformTheme = {
  colors: {
    ...c,
    darkYellow: c.yellow_dark,
    darkOrange: c.orange_dark,
    darkRed: c.red_dark,
    darkPink: c.pink_dark,
    darkPurple: c.purple_dark,
    darkBlue: c.blue_dark,
    darkTeal: c.teal_dark,
    darkGreen: c.green_dark,
    darkPetrol: c.petrol_dark,
    darkGrey: c.grey_dark,
    darkBrown: c.brown_dark,
    lightYellow: c.yellow_light,
    lightOrange: c.orange_light,
    lightRed: c.red_light,
    lightPink: c.pink_light,
    lightPurple: c.purple_light,
    lightBlue: c.blue_light,
    lightTeal: c.teal_light,
    lightGreen: c.green_light,
    lightPetrol: c.petrol_light,
    lightGrey: c.grey_light,
    lightBrown: c.brown_light,
  },
};
